<template>
  <div>
    <HeroBanner :page="'match'" />

    <MatchPlayers
      :playerOne="match.MatchPlayers[0]"
      :playerTwo="match.MatchPlayers[1]"
    />

    <MatchVisualisator
      v-if="match"
      :history="match.MatchLogs"
      :playerOne="match.MatchPlayers[0].userId"
      :playerTwo="match.MatchPlayers[1].userId"
    />

    <div class="container">
      <form @submit.prevent="newComment">
        <b-field grouped>
          <b-input v-model="comment" placeholder="Écrivez un commentaire..." expanded></b-input>
          <p class="control">
            <button class="button is-primary">Comment</button>
          </p>
        </b-field>
      </form>

      <MatchComments
        :comments="match.MatchComments"
        :playerOneId="match.MatchPlayers[0].userId"
        :playerTwoId="match.MatchPlayers[1].userId"
      />
    </div>
  </div>
</template>

<script>
import HeroBanner from '@/components/HeroBanner'
import NewTournamentButton from '@/components/NewTournamentButton'
import NewMatchButton from '@/components/NewMatchButton'
import MatchVisualisator from '@/components/MatchVisualisator'
import MatchComments from '@/components/MatchComments'
import MatchPlayers from '@/components/MatchPlayers'
import ApiMatchs from '@/api/matchs'
export default {
  components: {
    HeroBanner,
    NewTournamentButton,
    NewMatchButton,
    MatchVisualisator,
    MatchComments,
    MatchPlayers
  },
  data () {
    return {
      match: null,
      comment: ''
    }
  },
  created () {
    ApiMatchs.get.getMatch(this.$route.params.id).then(response => {
      this.match = response.body
    }).catch((error) => {
      throw error
    })
  },
  methods: {
    /**
     * Send new comment.
     * @TODO Mettre en place un anti-flood, et peut-être des règles à respecter pour les commentaires (max-length, etc.)
     * @TODO Add socket.io
     * @TODO Add limit, and load more via scrolling or by clicking more comments
     */
    newComment () {
      // Replace multiple spaces with one space
      let comment = this.comment.replace(/\s\s+/g, ' ')
      if (comment !== '' && comment.length > 0) {
        ApiMatchs.post.newComment(this.match.id, {comment: this.comment}).then(response => {
          if (response.body.success) {
            // Add comment in list, peut-être besoin de vuex (ou event emit pour le moment)
          } else {
            this.$snackbar.open({
              message: response.body.message,
              position: 'is-bottom-right',
              actionText: null
            })
          }
        })
      }
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/PageMatch.vue